import { Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";
import type { ProductPricingVariants } from "Components/Hunter/Merchants/types";
import type { ProductCode } from "Infrastructure/Api/Api";
import { getVariantCategoryName } from "Utils/merchantPricingUtils";

const RESOURCES = Resources.Components.Merchant.AppProducts.ProductAccordion;

type Props = {
  productCode: ProductCode;
  productPricings: Array<ProductPricingVariants>;
  currentPricingID?: number;
};

export const CurrentPricingFee = ({
  productCode,
  productPricings,
  currentPricingID,
}: Props) => {
  const { t } = useResource();

  const currentPricing = productPricings.find(
    ({ id }) => id === currentPricingID,
  );

  if (!currentPricing) {
    if (!currentPricingID) {
      return null;
    }

    return (
      <Typography variant="body1" color="text.secondary" textAlign="center">
        {t(RESOURCES.IndividualPricing)}
      </Typography>
    );
  }

  const categoryName = getVariantCategoryName(
    productCode,
    currentPricing.merchantPricingVariant,
    t,
  );

  const displayText = categoryName
    ? t(RESOURCES.FeeWithCategoryAndPricing, {
        categoryName,
        totalFee: currentPricing.totalFee,
        productName: currentPricing.productName,
      })
    : t(RESOURCES.FeeWithPricing, currentPricing);

  return (
    <Typography variant="body1" color="text.secondary" textAlign="center">
      {displayText}
    </Typography>
  );
};
